import { axios } from 'src/api'
import {
  ApiGetRateDataParams,
  ApiGetRateDataResponse
} from './getratedata.types'

export const ApiGetRateData = async ({
  serverPath,
  data,
  controller
}: ApiGetRateDataParams) => {
  const res = await axios.post<ApiGetRateDataResponse>(
    `https://${serverPath}/sialdPMS/web/resourcescrossorigin/seasonmanual/getratedata`,
    data,
    {
      signal: controller?.signal
    }
  )
  return res.data
}
